import { toast as sonnerToast, type ExternalToast } from "sonner";

const GLOBAL_TOAST_POSITION = "bottom-right" as const;

const TOAST_OPTIONS: ExternalToast = {
  position: GLOBAL_TOAST_POSITION,
};

function mergeOptions(data?: ExternalToast): ExternalToast {
  return { ...TOAST_OPTIONS, ...data, position: GLOBAL_TOAST_POSITION };
}

/** Só remove toasts do sistema (bottom-right) — não afeta toasts do Caixa (top-center). */
function dismissGlobalToasts() {
  for (const t of sonnerToast.getToasts()) {
    if (!("position" in t)) {
      sonnerToast.dismiss(t.id);
      continue;
    }
    if (!t.position || t.position === GLOBAL_TOAST_POSITION) {
      sonnerToast.dismiss(t.id);
    }
  }
}

type ToastFn = (message: string, data?: ExternalToast) => string | number;

function wrapToast(fn: ToastFn): ToastFn {
  return (message, data) => {
    dismissGlobalToasts();
    return fn(message, mergeOptions(data));
  };
}

export const toast = Object.assign(wrapToast(sonnerToast), {
  success: wrapToast(sonnerToast.success),
  error: wrapToast(sonnerToast.error),
  info: wrapToast(sonnerToast.info),
  warning: wrapToast(sonnerToast.warning),
  loading: wrapToast(sonnerToast.loading),
  message: wrapToast(sonnerToast.message),
  custom: sonnerToast.custom,
  dismiss: sonnerToast.dismiss,
  getHistory: sonnerToast.getHistory,
  getToasts: sonnerToast.getToasts,
  promise: <ToastData,>(
    promise: Parameters<typeof sonnerToast.promise<ToastData>>[0],
    data?: Parameters<typeof sonnerToast.promise<ToastData>>[1],
  ) => {
    dismissGlobalToasts();
    return sonnerToast.promise<ToastData>(promise, {
      ...data,
      position: GLOBAL_TOAST_POSITION,
    });
  },
});

export type { ExternalToast };
